module.exports = __webpack_public_path__ + "static/media/6_Prepare-Existing-Transformer-Cable-Label5.775673be.svg";